import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppDialogUiReduxObject, ConfirmationDialogButton, ConfirmationDialogComponent } from '@safarilaw-webapp/shared/dialog/store-access';
import { SafariFormComponent } from '@safarilaw-webapp/shared/ui-kit/safari-form';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LpmsMatterSubtypeTypeaheadComponent } from '../../../../shared/components/matter-subtype-typeahead/matter-subtype-typeahead.component';

@Component({
  selector: 'sl-lpms-change-subtype-confirmation-dialog',
  templateUrl: './change-subtype-dialog.component.html',
  styleUrls: ['./change-subtype-dialog.component.scss'],
  imports: [SafariFormComponent.standaloneImports, LpmsMatterSubtypeTypeaheadComponent, NgClass]
})
export class ChangeSubtypeDialogComponent extends ConfirmationDialogComponent {
  static ClassId = 'ChangeSubtypeDialogComponent_e195dc7a-70b8-11ed-a1eb-0242ac120002';
  ConfirmationDialogButton = ConfirmationDialogButton;

  form: FormGroup;
  constructor(
    dialogReduxObject: AppDialogUiReduxObject,
    bsModalService: BsModalService,
    store: Store<any>,
    actions: Actions,
    bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder
  ) {
    super(dialogReduxObject, bsModalService, store, actions, bsModalRef);
    this.form = this._formBuilder.group({
      matterSubtypeId: [null, Validators.required],
      matterSubtypePlaceholder: [null],
      matterSubtypeName: [null]
    });
  }

  closeModal(dialogButton: ConfirmationDialogButton = ConfirmationDialogButton.Auto) {
    if (dialogButton == ConfirmationDialogButton.Ok) {
      this.dialogData = {
        matterSubtypeId: this.form.get('matterSubtypeId').value,
        matterTypeId: this.data.find(o => o.id == this.form.get('matterSubtypeId').value).matterType
      };
    }
    super.closeModal(dialogButton);
  }
  get isOkDisabled() {
    return this.closeDialogRequestedBy != null || this.form.get('matterSubtypeId').value == null;
  }
}
